module.exports = "static/assets/75f5f189fdc419824a8134db6eb63881.woff2";